export let composeSendButton = "yoRiY";
export default {composeSendButton};